import { IContext } from "@src/context";
import { getDate } from "@src/utils/date";
import messages from "@src/containers/components/Rooms/messages";

export function parseDateFromString(dateString: string): Date | null {
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  const date = new Date(`${year}-${month}-${day}`);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date;
}

export function apartmentVisitsText(
  context: IContext,
  date: Date | null
): string {
  const { intl } = context;
  const today = new Date();
  if (!date) {
    return "";
  } else if (date <= today) {
    return intl.formatMessage(messages.apartmentVisitsNow);
  } else {
    return intl.formatMessage(
      messages.apartmentVisitsDate,
      getDate(context, date)
    );
  }
}

export function availableFromText(
  context: IContext,
  date: Date | null
): string {
  const { intl } = context;
  const today = new Date();
  if (!date) {
    return "";
  } else if (date <= today) {
    return intl.formatMessage(messages.availableFromNow);
  } else {
    return intl.formatMessage(
      messages.availableFromDate,
      getDate(context, date)
    );
  }
}
